const MOKA_SERVICE_HOST = process.env.MOKA_SERVICE_HOST

export const PIN_URL = `${MOKA_SERVICE_HOST}/account/v1/permissions/settings/pin`




// WEBPACK FOOTER //
// ./app/api/permissions/settings/constants.js